/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import { Image, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import AccountService from "../../../services/account.service";
import ConfirmationModal from "../../ConfirmationModal/ConfirmationModal";
import UpdateImageModal from './UpdateImageModal';
import { PageView, Event, Timing, ModalView } from "../../GoogleAnalytics";

import { jsPartner, jsAccount ,roles,notificationTime} from "../../../componentObjects";

import moment from 'moment';

import AddMultipleEmailAddresses from './AddMultipleEmailAddresses.js';
import AddIntegration from '../../Integrations/AddIntegration';
import MuteAlertConfirmationModal from "../../ConfirmationModal/MuteAlertConfirmationModal";
import PartnerService from '../../../services/partner.service';
import CustomerService from '../../../services/customer.service';
import billingService from '../../../services/billing.service';
import AssetService from '../../../services/asset.service';
import PhoneNumberInput from "../../Phone/PhoneNumberInput";
import {withRouter} from "../../Routing/withRouter";
import Loader from "../../Loader/Loader";
import {forEach} from "react-bootstrap/ElementChildren";

const jsUploadResults = {
    id: null,
    picture: null,
    data: null
};

const IndoorHubJobDefaultValue = 350;
const OutdoorHubJobDefaultValue = 400;

class AccountManagement extends Component {
    static displayName = AccountManagement.name;
    _isMounted = false;

    constructor(props) {
        super(props);

        this.getAccount = this.getAccount.bind(this);
        this.getPartnerProps = this.getPartnerProps.bind(this);

        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeDisplayName = this.onChangeDisplayName.bind(this);
        this.onChangeDescription = this.onChangeDescription.bind(this);
        // need on changes for logo.

        this.onChangeAddress = this.onChangeAddress.bind(this);
        this.onChangeCity = this.onChangeCity.bind(this);
        this.onChangeState = this.onChangeState.bind(this);
        this.onChangeZip = this.onChangeZip.bind(this);
        this.onChangePhone = this.onChangePhone.bind(this);
        this.onChangeBilling = this.onChangeBilling.bind(this);
        this.onChangeContract = this.onChangeContract.bind(this);
        this.onChangeBillingDate = this.onChangeBillingDate.bind(this);
        this.onChangeCompUnits = this.onChangeCompUnits.bind(this);
        this.onChangeAcCutoff = this.onChangeAcCutoff.bind(this);
        this.onChangeGasPrice = this.onChangeGasPrice.bind(this);
        this.onChangeElectricPrice = this.onChangeElectricPrice.bind(this);
        this.onChangeAvgFurnaceJob = this.onChangeAvgFurnaceJob.bind(this);
        this.onChangeAvgAirHandlerJob = this.onChangeAvgAirHandlerJob.bind(this);
        this.onChangeAvgAirConditionerJob = this.onChangeAvgAirConditionerJob.bind(this);
        this.onChangeAvgHeatPumpJob = this.onChangeAvgHeatPumpJob.bind(this);
        this.onChangeMaintenanceFee = this.onChangeMaintenanceFee.bind(this);
        this.onBlurPropertiesField = this.onBlurPropertiesField.bind(this);
        this.savePartnerProps = this.savePartnerProps.bind(this);
        this.onChangeApplicationNotificationTime = this.onChangeApplicationNotificationTime.bind(this);

        this.onCancel = this.onCancel.bind(this);
        this.onSave = this.onSave.bind(this);

        this.onContinueWithoutSaving = this.onContinueWithoutSaving.bind(this);
        this.onSaveThenContinue = this.onSaveThenContinue.bind(this);

        this.openCancelModal = this.openCancelModal.bind(this);
        this.showCancelModal = this.showCancelModal.bind(this);
        this.openSaveModal = this.openSaveModal.bind(this);
        this.showSaveModal = this.showSaveModal.bind(this);

        this.onUpdateLogo = this.onUpdateLogo.bind(this);
        this.onUpdateIcon = this.onUpdateIcon.bind(this);

        this.openLogoModal = this.openLogoModal.bind(this);
        this.showLogoModal = this.showLogoModal.bind(this);
        this.openIconModal = this.openIconModal.bind(this);
        this.showIconModal = this.showIconModal.bind(this);

        this.updatePartner = this.updatePartner.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
        this.handleIconChange = this.handleIconChange.bind(this);

        this.openSubscriptionModal = this.openSubscriptionModal.bind(this);
        this.showSubscriptionModal = this.showSubscriptionModal.bind(this);
        this.onUpgradeSubscription = this.onUpgradeSubscription.bind(this);

        this.onAddEmailClicked = this.onAddEmailClicked.bind(this);
        this.onDeleteEmailClicked = this.onDeleteEmailClicked.bind(this);
        this.onEmailChanged = this.onEmailChanged.bind(this);
        this.openAlertMuteUntilModal = this.openAlertMuteUntilModal.bind(this);
        this.onChangeMuteUntillDate = this.onChangeMuteUntillDate.bind(this);
        this.onSaveAlertMuteDate = this.onSaveAlertMuteDate.bind(this);
        this.asyntpartnerAttributes = this.asyntpartnerAttributes.bind(this);
        this.handleError = this.handleError.bind(this);
        this.onChangeEscalation = this.onChangeEscalation.bind(this);
        this.onChangeNotificationType = this.onChangeNotificationType.bind(this);
        this.toggleNotificationType = this.toggleNotificationType.bind(this);
        this.toggleAlertsToReview = this.toggleAlertsToReview.bind(this);
        

        this.state = {
            currentAccount: jsAccount,
            currentPartner: jsPartner,
            uploadLogoResults: jsUploadResults,
            uploadIconResults: jsUploadResults,
            currentLogo: null,
            currentIcon: null,
            updateLogo: null,
            updateIcon: null,
            updateLogoPath: null,
            updateIconPath: null,
            logoBytes: [],
            iconBytes: [],
            logoFileStorage: {
                name: '',
                byteArray: [],
                binaryString: ''
            },
            iconFileStorage: {
                name: "",
                byteArray: [],
                binaryString: ''
            },
            logoUpdated: false,
            newLogoFile: null,
            iconUpdated: false,
            newIconFile: null,
            message: "",
            loading: false,
            propsLoading: false,
            partnerProps: {},
            showCancelConfirm: false,
            showSaveConfirm: false,
            showLogoUpdate: false,
            showIconUpdate: false,
            showSubscriptionUpgrade: false,
            modalMessage: "",
            modalTitle: "",
            isCustomerSupport: localStorage.getItem('isCustomerSupport') === 'true' || false,
            startTime: moment().date(1),
            selectedMutedDate: "",
            alertMuteDate:"",
            unsavedChanges: localStorage.getItem("unsavedChanges") === 'true' || false,
            showUnsavedModal: null,
            error: "",
            isUpdating: false,
            selectedContractType: [],
            selectedNotificationType:  []
        };
    }

    getStorageValue(key, defaultValue, isJson = false) {
        const saved = localStorage.getItem(key);
        var value = saved !== null ? saved : defaultValue;
        if (isJson && value !== defaultValue && value !== "") {
            try {
                value = JSON.parse(value);
            }
            catch(e) {
                console.log(e);
                console.log(`error parsing value: ${value}`);
            }
        }
        return value;
    }

    componentDidMount() {
        this._isMounted = true;
        PageView();
        let unsavedChanges = this.getStorageValue("unsavedChanges", false);
            if (unsavedChanges === true || unsavedChanges === 'true') {
                let partner = this.getStorageValue("currentPartner", jsPartner, true);
                let props = this.getStorageValue("partnerProps", '{}', true);
                this.setState({ 
                    unsavedChanges: unsavedChanges,
                    currentPartner: partner,
                    partnerProps: props
                });
            }
            else {
                this.getAccount();
                this.asyntpartnerAttributes();
                this.getPartnerProps();
            }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentPartnerId !== this.props.currentPartnerId) {
            this.getAccount();
            this.asyntpartnerAttributes();
            this.getPartnerProps();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    //memPartner = memoize(this.getAccount);
    handleError(error){
        this.setState({error});
    }
    onChangeName(e) {
        const newName = e.target.value;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    name: newName
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }
    
     onChangeMuteUntillDate(e) {
        this.setState({
            selectedMutedDate: e
        });
     }
    onChangeDisplayName(e) {
        const newName = e.target.value;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    company: newName
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeDescription(e) {
        const newName = e.target.value;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    description: newName
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeAddress(e) {
        const newAddress = e.target.value;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    address: newAddress
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeCity(e) {
        const newCity = e.target.value;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    city: newCity
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeState(e) {
        const newState = e.target.value;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    state: newState
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeZip(e) {
        const newZip = e.target.value;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    zip: newZip
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangePhone(e) {
        const newPhone = e;

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    phone: newPhone
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeBilling(e) {
        const newBilling = e.target.value;
        let contractType = this.state.selectedContractType;
        if(newBilling === "0") {
            contractType = [];
        }

       

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                selectedContractType: contractType,
                currentPartner: {
                    ...prevState.currentPartner,
                    isBillable: newBilling,
                    contractType: ""
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeApplicationNotificationTime(e) {
        const newNotifiationTime = e.target.value;
        let notificationType = this.state.selectedNotificationType?.includes('Email');
        if(notificationType)
        {
            this.setState(function (prevState) {
                return {
                    unsavedChanges: true,
                  
                    currentPartner: {
                        ...prevState.currentPartner,
                        applicationNotificationTime: newNotifiationTime,
                       
                    }
                };
            }, () => {
               
                localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
                localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
            });
        }
    }

    toggleAlertsToReview(e)
    {
        const alertsToReviewValue =  e.target.checked;
        
        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
             
                currentPartner: {
                    ...prevState.currentPartner,
                    alertsToReview: alertsToReviewValue,
                }
            };
        }, () => {
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeEscalation(e) {
        const newEscalationType = e.target.value;
        let escalationType = this.state.selectedNotificationType;
        if(newEscalationType === "0") {
            escalationType = ["NoData"];
        }


        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                selectedNotificationType: escalationType,
                currentPartner: {
                    ...prevState.currentPartner,
                    escalationType: newEscalationType,
                    notificationType: "NoData"
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    toggleContractType(array, element) {
        if (array.includes(element)) {
            const index = array.indexOf(element);
            array.splice(index, 1);
        } else {
            array.push(element);
        }
    }

    toggleNotificationType(array, element) {
        if (array.includes(element)) {
            const index = array.indexOf(element);
            array.splice(index, 1);
        } else {
            array.push(element);
        }
        if(array.length > 1 && array.includes("NoData"))
        {
            const index = array.indexOf("NoData");
            array.splice(index, 1);
        }
    }
    onChangeContract(e) {
        let contractTypeArray = this.state.selectedContractType;
        this.toggleContractType(contractTypeArray, e.target.value);
        const newContract = contractTypeArray.join();
        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                selectedContractType: contractTypeArray,
                currentPartner: {
                    ...prevState.currentPartner,
                    contractType: newContract
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeNotificationType(e) {
        let newNotificationTypeArray = this.state.selectedNotificationType;
        let ApplicationNotificationTime = this.state.applicationNotificationTime;
        this.toggleNotificationType(newNotificationTypeArray, e.target.value);
        const newArray = newNotificationTypeArray.join();
        if(!newArray.includes("Email"))
        {
            ApplicationNotificationTime = "";
        }
        else {
            ApplicationNotificationTime = "0";
        }
        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                selectedNotificationType: newNotificationTypeArray,
                currentPartner: {
                    ...prevState.currentPartner,
                    notificationType: newArray,
                    applicationNotificationTime: ApplicationNotificationTime
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeBillingDate(e) {
        //const newValue = e.target.value;
        let newDate = moment(e).date(1).format("MM/DD/YYYY");

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    firstBillingDate: newDate
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeCompUnits(e) {
        let newValue = e.target.value;
        if (parseInt(newValue) > 10)
            newValue = "10";
        else if (parseInt(newValue) < 0)
            newValue = "0";

        this.setState(function (prevState) {
            return {
                unsavedChanges: true,
                currentPartner: {
                    ...prevState.currentPartner,
                    complementaryUnits: newValue
                }
            };
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
        });
    }

    onChangeAcCutoff(e) {
        let acCutoffTemp = e.target.value;
        acCutoffTemp = acCutoffTemp.replace(" °", "");
        acCutoffTemp = acCutoffTemp.replace("F", "");
        this.setState({ unsavedChanges: true, partnerProps: {
                ...this.state.partnerProps,
                acCutoffTemp: acCutoffTemp //parseInt(acCutoffTemp, 10)
            }
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("partnerProps", JSON.stringify(this.state.partnerProps));
        });
    }

    onChangeElectricPrice(e) {
        let electricPrice = e.target.value;
        electricPrice = electricPrice.replace('$', '');
        this.setState({ unsavedChanges: true, partnerProps: {
                ...this.state.partnerProps,
                electricPrice: electricPrice //parseFloat(electricPrice).toFixed(2)
            }
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("partnerProps", JSON.stringify(this.state.partnerProps));
        });
    }

    onChangeGasPrice(e) {
        let gasPrice = e.target.value;
        gasPrice = gasPrice.replace('$', '');
        this.setState({ unsavedChanges: true, partnerProps: {
                ...this.state.partnerProps,
                gasPrice: gasPrice //parseFloat(gasPrice).toFixed(2)
            }
        }, () => {
            //this.props.setUnsavedChanges(true);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
            localStorage.setItem("partnerProps", JSON.stringify(this.state.partnerProps));
        });
    }
    onChangeAvgFurnaceJob(e) {
        let avgFurnaceJob = e.target.value;
        avgFurnaceJob = avgFurnaceJob.replace('$', '');
        this.setState({ partnerProps: {
                ...this.state.partnerProps,
                avgFurnaceJob: avgFurnaceJob
            }
        });
    }

    onChangeAvgAirHandlerJob(e) {
        let avgAirHandlerJob = e.target.value;
        avgAirHandlerJob = avgAirHandlerJob.replace('$', '');
        this.setState({ partnerProps: {
                ...this.state.partnerProps,
                avgAirHandlerJob: avgAirHandlerJob
            }
        });
    }

    onChangeAvgAirConditionerJob(e) {
        let avgAirConditionerJob = e.target.value;
        avgAirConditionerJob = avgAirConditionerJob.replace('$', '');
        this.setState({ partnerProps: {
                ...this.state.partnerProps,
                avgAirConditionerJob: avgAirConditionerJob
            }
        });
    }

    onChangeAvgHeatPumpJob(e) {
        let avgHeatPumpJob = e.target.value;
        avgHeatPumpJob = avgHeatPumpJob.replace('$', '');
        this.setState({ partnerProps: {
                ...this.state.partnerProps,
                avgHeatPumpJob: avgHeatPumpJob
            }
        });
    }

    onChangeMaintenanceFee(e) {
        let maintenanceFee = e.target.value;
        maintenanceFee = maintenanceFee.replace('$', '');
        this.setState({ partnerProps: {
                ...this.state.partnerProps,
                maintenanceFee: maintenanceFee
            }
        });
    }
    onBlurPropertiesField(e) {
        if (e.target.id === "electricPrice") {
            let electricPrice = e.target.value;
            electricPrice = electricPrice.replace('$', '');
            this.setState({ unsavedChanges: true, partnerProps: {
                    ...this.state.partnerProps,
                    electricPrice: parseFloat(electricPrice).toFixed(3)
                }
            }, () => {
                localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
                localStorage.setItem("partnerProps", JSON.stringify(this.state.partnerProps));
            });
        }
        else if (e.target.id === "gasPrice") {
            let gasPrice = e.target.value;
            gasPrice = gasPrice.replace('$', '');
            this.setState({ unsavedChanges: true, partnerProps: {
                    ...this.state.partnerProps,
                    gasPrice: parseFloat(gasPrice).toFixed(3)
                }
            }, () => {
                localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
                localStorage.setItem("partnerProps", JSON.stringify(this.state.partnerProps));
            });
        }
        else if (e.target.id === "acCutoffTemp") {
            let acCutoffTemp = e.target.value;
            acCutoffTemp = acCutoffTemp.replace(" °", "");
            acCutoffTemp = acCutoffTemp.replace("F", "");
            let acCutoffTempValue = parseInt(acCutoffTemp, 10);
            if (acCutoffTempValue > 100) {
                acCutoffTempValue = 100;
            }
            this.setState({ unsavedChanges: true, partnerProps: {
                    ...this.state.partnerProps,
                    acCutoffTemp: acCutoffTempValue
                }
            }, () => {
                localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
                localStorage.setItem("partnerProps", JSON.stringify(this.state.partnerProps));
            });
        }
        else if (e.target.id === "avgFurnaceJob") {
            let avgFurnaceJob = e.target.value;
            avgFurnaceJob = avgFurnaceJob.replace('$', '');
            if (avgFurnaceJob <= 0) {
                avgFurnaceJob = IndoorHubJobDefaultValue;
            }
            this.setState({ partnerProps: {
                    ...this.state.partnerProps,
                    avgFurnaceJob: parseFloat(avgFurnaceJob).toFixed(2)
                }
            });
        }
        else if (e.target.id === "avgAirHandlerJob") {
            let avgAirHandlerJob = e.target.value;
            avgAirHandlerJob = avgAirHandlerJob.replace('$', '');
            if (avgAirHandlerJob <= 0) {
                avgAirHandlerJob = IndoorHubJobDefaultValue;
            }
            this.setState({ partnerProps: {
                    ...this.state.partnerProps,
                    avgAirHandlerJob: parseFloat(avgAirHandlerJob).toFixed(2)
                }
            });
        }
        else if (e.target.id === "avgAirConditionerJob") {
            let avgAirConditionerJob = e.target.value;
            avgAirConditionerJob = avgAirConditionerJob.replace('$', '');
            if (avgAirConditionerJob <= 0) {
                avgAirConditionerJob = OutdoorHubJobDefaultValue;
            }
            this.setState({ partnerProps: {
                    ...this.state.partnerProps,
                    avgAirConditionerJob: parseFloat(avgAirConditionerJob).toFixed(2)
                }
            });
        }
        else if (e.target.id === "avgHeatPumpJob") {
            let avgHeatPumpJob = e.target.value;
            avgHeatPumpJob = avgHeatPumpJob.replace('$', '');
            if (avgHeatPumpJob <= 0) {
                avgHeatPumpJob = OutdoorHubJobDefaultValue;
            }
            this.setState({ partnerProps: {
                    ...this.state.partnerProps,
                    avgHeatPumpJob: parseFloat(avgHeatPumpJob).toFixed(2)
                }
            });
        }
        else if (e.target.id === "maintenanceFee") {
            let maintenanceFee = e.target.value;
            maintenanceFee = maintenanceFee.replace('$', '');
            this.setState({ partnerProps: {
                    ...this.state.partnerProps,
                    maintenanceFee: parseFloat(maintenanceFee).toFixed(2)
                }
            });
        }
    }

    showSubscriptionModal() {
        this.setState({
            showSubscriptionUpgrade: !this.state.showSubscriptionUpgrade
        }, () => {
            if (this.state.showSubscriptionUpgrade)
                ModalView("partnerAccount/subscriptionUpdate");
        });
    }

    openSubscriptionModal() {
        this.showSubscriptionModal();
    }

    onUpgradeSubscription(newSubId) {

    }
    
    openAlertMuteUntilModal() 
    {
        this.setState({
            showMuteAlertConfirm : !this.state.showMuteAlertConfirm
        });
    }
    
     asyntpartnerAttributes() {
        // ACAlertMuteDate is stored in TT org attributes — skip for pro-only partners
        if (!this.props.currentPartnerId || isNaN(parseInt(this.props.currentPartnerId))) return;

        CustomerService.getorgdetail(this.props.currentPartnerId)
            .then(response => {
                var acalertMuteDate = response?.data?.attributes?.find(x => x.name == "ACAlertMuteDate");
                if (acalertMuteDate != undefined) {
                    var muteDate = new Date(acalertMuteDate?.value).toLocaleDateString();
                    if (this._isMounted)
                        this.setState({
                            alertMuteDate: muteDate,
                            selectedMutedDate: new Date(acalertMuteDate?.value)
                        });
                } else {
                    if (this._isMounted)
                        this.setState({
                            alertMuteDate: "NA",
                            selectedMutedDate: new Date()
                        });
                }
            }).catch(e => {
                console.log(e)
            });
    }
    
    showCancelModal() {
        this.setState({
            showCancelConfirm: !this.state.showCancelConfirm
        }, () => {
                if (this.state.showCancelConfirm)
                    ModalView("partnerAccount/cancelConfirm");
        });
        window.scrollTo(0, 0);
    }

    openCancelModal() {
        this.setState({ modalMessage: "Are you sure you want to undo all changes?", modalTitle: "Undo Changes" }, () => {
            this.showCancelModal();
        });
    }

     onSaveAlertMuteDate() {
        const selectedmutedate = new Date(this.state.selectedMutedDate).toLocaleDateString();
        PartnerService.updatemuteuntilalert(this.props.currentPartnerId, selectedmutedate).then(response => {
                if (response === true) {
                    billingService.getpartnersubscriptions(this.props.currentPartnerId)
                      .then(response => { this.asyntpartnerAttributes(); }).catch (e => {
                          this.showTemporaryMessage( "AC Alert mute until date is updated successfully");
                    });
                    Event("AC Alert Mute Update", "User clicked button to save changes AC Alert Mute Update", "AC Alert Mute Update Save Clicked");
                    this.setState({
                        showMuteAlertConfirm: !this.state.showMuteAlertConfirm
                    });
                }
                else {
                    this.showTemporaryMessage("Failed to update AC Alert mute until date!");
                    this.setState({
                       showMuteAlertConfirm: !this.state.showMuteAlertConfirm
                    });
                }
            }).catch(e => {
                this.showTemporaryMessage("Failed to update AC Alert mute until date!");
            });
     }
    
    showSaveModal() {
        this.setState({
            showSaveConfirm: !this.state.showSaveConfirm
        }, () => {
                if (this.state.showSaveConfirm)
                    ModalView("partnerAccount/saveConfirm");
        });
        window.scrollTo(0, 0);
    }

    openSaveModal() {
        this.setState({ modalMessage: "Are you sure you want to save all changes?", modalTitle: "Save Changes" }, () => {
            this.showSaveModal();
        });
    }

    onSave() {
        this.updatePartner();
        this.savePartnerProps();
        this.setState({ showSaveConfirm: !this.state.showSaveConfirm, unsavedChanges: false }, () => {
            this.props.setUnsavedChanges(false);
            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
        });
    }

    onCancel() {
        var startTime = performance.now();
        this.setState({ loading: true });

        // For pro-only partners, re-fetch from RIS instead
        if (isNaN(parseInt(this.props.currentPartnerId))) {
            this.getAccount();
            this.setState({ showCancelConfirm: false, unsavedChanges: false }, () => {
                localStorage.setItem("unsavedChanges", false);
            });
            return;
        }

        AccountService.getpartnerinfo(this.props.currentPartnerId)
            .then(response => {
                if (this._isMounted)                    
                    this.setState({
                        currentPartner: response.data, showCancelConfirm: !this.state.showCancelConfirm, loading: false, message: "Changes undone successfully!", unsavedChanges: false
                    }, () => {
                            localStorage.setItem("unsavedChanges", this.state.unsavedChanges);
                            localStorage.setItem("currentPartner", JSON.stringify(this.state.currentPartner));
                            localStorage.setItem("showUnsavedModal", false);
                            var elapsedTime = performance.now - startTime;
                            Timing("Cancelling Changes to Partner Account", "loading", elapsedTime, "Cancelling Changes to Partner Account");
                            Event("Partner Cancel", "User clicked button to cancel changes to partner account", "Partner Account Cancel Clicked");
                    });
            })
            .catch(e => {
                console.log(e);
            });
    }

    onContinueWithoutSaving() {
        localStorage.setItem("unsavedChanges", false);
        localStorage.setItem("showUnsavedModal", false);
        localStorage.setItem("currentPartner", JSON.stringify(jsPartner));
        localStorage.setItem("partnerProps", '{}');
        let nextPath = this.getStorageValue("nextPath", null);

        this.props.navigate(nextPath);
        this.props.setActivePath(nextPath);
    }

    onSaveThenContinue() {
        this.setState({ showUnsavedModal: false }, () => {
            localStorage.setItem("showUnsavedModal", false);
            let partner = this.getStorageValue("currentPartner", jsPartner, true);
            let props = this.getStorageValue("partnerProps", '{}', true);
            
            this.setState({ currentPartner: partner, partnerProps: props }, () => {
                this.updatePartner(true);
            });
        })
    }

    showLogoModal() {
        this.setState({
            showLogoUpdate: !this.state.showLogoUpdate
        }, () => {
                if (this.state.showLogoUpdate)
                    ModalView("partnerAccount/logoUpdate");
        });
        window.scrollTo(0, 0);
    }

    openLogoModal() {
        this.setState({ modalMessage: "Choose new Logo to upload (PNG, JPG):", modalTitle: "Update Logo" }, () => {
            this.showLogoModal();
        });
    }

    showIconModal() {
        this.setState({
            showIconUpdate: !this.state.showIconUpdate
        }, () => {
                if (this.state.showIconUpdate)
                    ModalView("partnerAccount/iconUpdate");
        });
        window.scrollTo(0, 0);
    }

    openIconModal() {
        this.setState({ modalMessage: "Choose new Icon to upload (PNG, JPG):", modalTitle: "Update Icon" }, () => {
            this.showIconModal();
        });
    }

    onUpdateLogo() {
        Event("Partner Update Logo", "User uploaded new partner logo", "Update Partner Account Logo Clicked");
        AccountService.uploadimage(this.state.logoFileStorage)
            .then(response => {
                this.setState({
                    uploadLogoResults: response.data, showLogoUpdate: !this.state.showLogoUpdate
                }, () => {
                        this.setState(function (prevState) {
                            return {
                                logoUpdated: true,
                                currentPartner: {
                                    ...prevState.currentPartner,
                                    logo: this.state.uploadLogoResults.picture,
                                    logoId: this.state.uploadLogoResults.id,
                                    logoData: this.state.uploadLogoResults.data
                                }
                            };
                        });
                });
            })
    }

    handleLogoChange(file) {
        this.setState({ updateLogo: file, updateLogoPath: file.name });
        let reader = new FileReader();
        var fileByteArray = [];
        //var binaryString = "";
        reader.readAsArrayBuffer(file);
        reader.onloadend = function (e) {
            if (e.target.readyState === FileReader.DONE) {
                var arrayBuffer = e.target.result,
                    array = new Uint8Array(arrayBuffer);
                    //binaryString = String.fromCharCode.apply(null, array)
                //console.log(binaryString);

                for (var i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                }
            }
        }
        this.setState({ logoFileStorage: { name: file.name, byteArray: fileByteArray }, logoBytes: fileByteArray, newLogoFile: URL.createObjectURL(file) });
    }

    onUpdateIcon() {
        Event("Partner Update Icon", "User uploaded new partner icon", "Update Partner Account Icon Clicked");
        AccountService.uploadimage(this.state.iconFileStorage)
            .then(response => {
                this.setState({
                    uploadIconResults: response.data, showIconUpdate: !this.state.showIconUpdate
                }, () => {
                    this.setState(function (prevState) {
                        return {
                            iconUpdated: true,
                            currentPartner: {
                                ...prevState.currentPartner,
                                icon: this.state.uploadIconResults.picture,
                                iconId: this.state.uploadIconResults.id,
                                iconData: this.state.uploadIconResults.data
                            }
                        };
                    });
                });
            })
    }

    handleIconChange(file) {
        this.setState({ updateIcon: file, updateIconPath: file.name });
        let reader = new FileReader();
        var fileByteArray = [];
        //var binaryString = "";
        reader.readAsArrayBuffer(file);
        reader.onloadend = function (e) {
            if (e.target.readyState === FileReader.DONE) {
                var arrayBuffer = e.target.result,
                    array = new Uint8Array(arrayBuffer);
                    //binaryString = String.fromCharCode.apply(null, array);

                //console.log(binaryString);

                for (var i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                }
            }
        }
        this.setState({ iconFileStorage: { name: file.name, byteArray: fileByteArray }, iconBytes: fileByteArray, newIconFile: URL.createObjectURL(file) });
    }

    onAddEmailClicked = () => {
        Event("Add Email Clicked", "User clicked to Add Email to Partner Account", "Add Email Clicked");
        this.state.currentPartner.notificationEmailAddresses.push("");
        this.updateNotificationEmailAddresses(this.state.currentPartner.notificationEmailAddresses);       
    }

    onDeleteEmailClicked = (position) => {
        Event("Delete Email Clicked", "User clicked to Delete Email from Partner Account", "Delete Email Clicked");
        this.state.currentPartner.notificationEmailAddresses.splice(position, 1);
        this.updateNotificationEmailAddresses(this.state.currentPartner.notificationEmailAddresses);        
    }

    onEmailChanged = (e, value, position) => {
        Event("Email Changed", "User changed Email for Partner Account", "Email Changed");
        let newEmailAddresses = this.state.currentPartner.notificationEmailAddresses.slice();
        newEmailAddresses[position] = value;
        this.updateNotificationEmailAddresses(newEmailAddresses);       
    }

    updateNotificationEmailAddresses(emailAddresses) {
        this.setState(function (prevState) {
            return {
                currentPartner: {
                    ...prevState.currentPartner,
                    notificationEmailAddresses: emailAddresses
                }
            };
        });
    }

    async cleanseEmailAddresses() {
        if (this.state.currentPartner.notificationEmailAddresses.length > 0) {
            const cleansedEmails = [];

            this.state.currentPartner.notificationEmailAddresses.forEach(email => {
                if (email !== "") {
                    cleansedEmails.push(email.trim());
                }
            });        

            this.updateNotificationEmailAddresses(cleansedEmails);            
        }
    }

    updatePartner(goNextPage = false) {
        this.cleanseEmailAddresses().then(() => {
            const isProOnly = !this.state.currentPartner.organizationId
                && !!this.state.currentPartner.proPartnerAccountId;

            // For TT-backed partners, require a phone number before saving.
            // For pro-only partners the RIS update doesn't enforce this.
            if (!isProOnly && (!this.state.currentPartner.phone || this.state.error)) return;
            if (this.state.error) return;

            this.setState({isUpdating: true});

            // Ensure proPartnerAccountId is included in the payload
            const partnerPayload = {
                ...this.state.currentPartner,
                proPartnerAccountId: this.state.currentPartner.proPartnerAccountId || ""
            };

            AccountService.updateorg(partnerPayload)
                .then(response => {
                    if (response.data === true && this._isMounted) {
                        this.setState({
                            message: "Partner Account updated successfully!"
                        }, () => {
                            if (this.state.loading === false) {
                                this.setState({
                                    loading: true
                                }, () => {
                                        this.getAccount(goNextPage);
                                });
                            }
                        });
                        Event("Partner Update", "User clicked button to save changes to partner account", "Partner Account Save Clicked");
                    }
                    else {
                        this.showTemporaryMessage("Failed to update partner account!");
                    }
                    this.setState({isUpdating: false});
                }).catch(e => {
                    this.showTemporaryMessage("Failed to update partner account!");
                    this.setState({isUpdating: false});
                });
        }).catch(err => {
            this.showTemporaryMessage("Failed to update partner account!")
        });
    }

    showTemporaryMessage(message) {
        if (this._isMounted) {
            this.setState({
                message: message
            });
    
            setTimeout(() => {
                this.setState({
                    message: ""
                });
            }, 3000);
        }
    }

    getAccount(goNextPage = false) {
            this.setState({ loading: true }, async () => {
                var startTime = performance.now();
                this.setState({ currentPartner: jsPartner, logoUpdated: false, iconUpdated: false }, async () => {

                    const isProOnly = this.props.currentPartnerId
                        && isNaN(parseInt(this.props.currentPartnerId));

                    if (isProOnly) {
                        // Pro-only partner: fetch RIS company data, then immediately fetch TT
                        // shadow twin properties to populate billing, contract, escalation, etc.
                        // Both fetches happen sequentially here so there is no race condition with
                        // the concurrent getPartnerProps() call (which only manages partnerProps).
                        try {
                            const risResponse = await PartnerService.getpropartnerdetail(this.props.currentPartnerId);
                            const datum = risResponse?.data;
                            if (datum && this._isMounted) {
                                const mapped = this.mapRisPartnerToState(datum);

                                // Fetch TT shadow twin properties for billing/contract/escalation fields
                                let infoFromProps = null;
                                try {
                                    const propsResponse = await PartnerService.getpartnerproperties(this.props.currentPartnerId);
                                    infoFromProps = this.mapPartnerInfoFromProps(propsResponse);
                                } catch (pe) {
                                    console.log("Could not fetch TT props for pro partner:", pe);
                                }

                                const fullPartner = infoFromProps
                                    ? { ...mapped, ...infoFromProps }
                                    : mapped;

                                this.setState({
                                    currentPartner: fullPartner,
                                    selectedContractType: infoFromProps?.contractType
                                        ? infoFromProps.contractType.split(",").filter(i => i)
                                        : [],
                                    selectedNotificationType: infoFromProps?.notificationType
                                        ? infoFromProps.notificationType.split(",").filter(i => i)
                                        : [],
                                    loading: false
                                }, () => {
                                    localStorage.setItem("unsavedChanges", false);
                                    localStorage.setItem("showUnsavedModal", false);
                                    const elapsedTime = performance.now() - startTime;
                                    Timing("Partner Account Loading", "loading", elapsedTime, "Partner Account Loading (Pro)");
                                    if (goNextPage) this.onContinueWithoutSaving();
                                });
                            } else {
                                this.setState({ loading: false });
                            }
                        } catch (e) {
                            console.log(e);
                            this.setState({ loading: false });
                        }
                        return;
                    }

                    // Legacy TT partner: use getpartnerinfo as before
                    await AccountService.getpartnerinfo(this.props.currentPartnerId)
                        .then(async response => {
                            if (this._isMounted){
                                let partner = response.data;

                                // If the legacy partner also has a ProPartnerAccountId, supplement
                                // empty fields with live RIS data
                                if (partner?.proPartnerAccountId) {
                                    try {
                                        const risResponse = await PartnerService.getpropartnerdetail(partner.proPartnerAccountId);
                                        const datum = risResponse?.data;
                                        if (datum) {
                                            partner = this.supplementPartnerWithRis(partner, datum);
                                        }
                                    } catch (e) {
                                        console.log("Could not fetch RIS partner detail for supplement:", e);
                                    }
                                }

                                this.setState({
                                    currentPartner: partner,
                                    selectedContractType: partner.contractType
                                        ? partner.contractType.split(",").filter(i => i)
                                        : [],
                                    selectedNotificationType: partner.notificationType
                                        ? partner.notificationType.split(",").filter(i => i)
                                        : [],
                                    loading: false
                                }, () => {
                                    setTimeout(() => {
                                        if (this._isMounted) this.setState({ message: "" });
                                    }, 3000);
                                    localStorage.setItem("unsavedChanges", false);
                                    localStorage.setItem("showUnsavedModal", false);
                                    const elapsedTime = performance.now() - startTime;
                                    Timing("Partner Account Loading", "loading", elapsedTime, "Partner Account Loading");
                                    if (goNextPage) this.onContinueWithoutSaving();
                                });
                            }
                        })
                        .catch(e => {
                            console.log(e);
                            this.setState({ loading: false });
                        });
                });
            })
    }

    /**
     * Maps a RIS Datum (company) object to the currentPartner state shape.
     * Used when the partner exists only in RIS (no TT integer org ID).
     */
    mapRisPartnerToState(datum) {
        return {
            ...jsPartner,
            name: datum.name || "",
            company: datum.name || "",
            description: "",
            address: datum.shipToAddress?.addressLine1 || "",
            city: datum.shipToAddress?.city || "",
            state: datum.shipToAddress?.stateProvinceRegionCode || "",
            zip: datum.shipToAddress?.zipPostalCode || "",
            country: datum.shipToAddress?.countryCode || "",
            phone: datum.primaryPhoneNumber || "",
            // logo comes as a URL from RIS, not base64 — store in logo field
            logo: datum.partnerBrandProfile?.logo || null,
            logoData: null,
            icon: null,
            iconData: null,
            notificationEmailAddresses: datum.partnerUsers
                ?.map(u => u.user?.contactEmail)
                .filter(Boolean) || [],
            proPartnerAccountId: datum.id || ""
        };
    }

    /**
     * Fills in empty fields on a legacy TT partner object with data from RIS.
     * RIS data does NOT override existing TT values.
     */
    supplementPartnerWithRis(partner, datum) {
        return {
            ...partner,
            name: partner.name || datum.name || "",
            address: partner.address || datum.shipToAddress?.addressLine1 || "",
            city: partner.city || datum.shipToAddress?.city || "",
            state: partner.state || datum.shipToAddress?.stateProvinceRegionCode || "",
            zip: partner.zip || datum.shipToAddress?.zipPostalCode || "",
            phone: partner.phone || datum.primaryPhoneNumber || "",
            proPartnerAccountId: partner.proPartnerAccountId || datum.id || ""
        };
    }

    /**
     * Extracts partner-info fields stored as TT shadow twin properties.
     * These are written by the legacy getpartnerinfo path but for pro-only partners
     * we read them directly from the partnerpropertiesbypro response.
     */
    mapPartnerInfoFromProps(propsList) {
        if (!propsList || !Array.isArray(propsList)) return null;
        const find = (name) => propsList.find(obj => obj.name === name)?.value;

        const isBillable         = find("IsBillable");
        const contractType       = find("ContractType");
        const firstBillingDate   = find("FirstBillingDate");
        const complementaryUnits = find("ComplementaryUnits");
        const escalationType     = find("EscalationType");
        const notificationType   = find("NotificationType");
        const appNotifTime       = find("ApplicationNotificationTime");
        const alertsToReview     = find("AlertsToReview");
        const betaST             = find("Beta-ST");

        return {
            isBillable:                isBillable        ?? "",
            contractType:              contractType       ?? "",
            firstBillingDate:          firstBillingDate   ?? "",
            complementaryUnits:        complementaryUnits ?? "0",
            escalationType:            escalationType     ?? "",
            notificationType:          notificationType   ?? "",
            applicationNotificationTime: appNotifTime     ?? "0",
            alertsToReview:            alertsToReview === "1" || alertsToReview === "true",
            betaST:                    betaST === "1"
        };
    }

    getPartnerProps() {
        // getpartnerproperties auto-routes to the pro tag-based endpoint for non-integer IDs.
        // This method only manages partnerProps (acCutoffTemp, electricPrice, etc.).
        // Partner-info fields (billing, contract, escalation) for pro-only partners are
        // fetched sequentially inside getAccount() to avoid race conditions.
        if (!this.props.currentPartnerId) return;

        if (this._isMounted) {
            this.setState({ propsLoading: true }, async () => {
                var startTime = performance.now();
                this.setState({ partnerProps: {} }, async () => {
                    await PartnerService.getpartnerproperties(this.props.currentPartnerId)
                        .then(response => {
                            if (this._isMounted)
                                this.setState({
                                    partnerProps: this.mapPartnerProps(response), propsLoading: false
                                }, () => {
                                    localStorage.setItem("partnerProps", JSON.stringify(this.state.partnerProps));
                                    var elapsedTime = performance.now() - startTime;
                                    Timing("Partner Properties Loading", "loading", elapsedTime, "Partner Properties Loading");
                                });
                        })
                        .catch(e => {
                            console.log(e);
                            if (this._isMounted) this.setState({ propsLoading: false });
                        });
                });
            })
        }
    }

    mapPartnerProps(propsList) {
        if (!propsList || !Array.isArray(propsList)) {
            return {
                shadowTwinAssetId: "",
                acCutoffTemp: 65,
                electricPrice: (0).toFixed(3),
                gasPrice: (0).toFixed(3),
                avgFurnaceJob: (350).toFixed(2),
                avgAirHandlerJob: (350).toFixed(2),
                avgAirConditionerJob: (400).toFixed(2),
                avgHeatPumpJob: (400).toFixed(2),
                maintenanceFee: (0).toFixed(2)
            };
        }

        let shadowTwinAssetId = propsList.find(obj => obj.name === "shadowTwinAssetId")?.valueRaw;
        let acCutoffTemp = propsList.find(obj => obj.name === "acCutoffTemp")?.valueRaw;
        let electricPrice = propsList.find(obj => obj.name === "electricPrice")?.valueRaw;
        let gasPrice = propsList.find(obj => obj.name === "gasPrice")?.valueRaw;

        let avgFurnaceJob = propsList.find(obj => obj.name === "avgFurnaceJob")?.valueRaw;
        let avgAirHandlerJob = propsList.find(obj => obj.name === "avgAirHandlerJob")?.valueRaw;
        let avgAirConditionerJob = propsList.find(obj => obj.name === "avgAirConditionerJob")?.valueRaw;
        let avgHeatPumpJob = propsList.find(obj => obj.name === "avgHeatPumpJob")?.valueRaw;
        let maintenanceFee = propsList.find(obj => obj.name === "maintenanceFee")?.valueRaw;
        
        let partnerProps = {
            shadowTwinAssetId: shadowTwinAssetId === null || shadowTwinAssetId === undefined ? "" : shadowTwinAssetId,
            acCutoffTemp: acCutoffTemp === null || acCutoffTemp === undefined ? 65 : parseInt(acCutoffTemp, 10).toFixed(0),
            electricPrice: electricPrice === null || electricPrice === undefined ? 0.00 : parseFloat(electricPrice).toFixed(3),
            gasPrice: gasPrice === null || gasPrice === undefined ? 0.00 : parseFloat(gasPrice).toFixed(3),
            avgFurnaceJob: avgFurnaceJob === null || avgFurnaceJob === undefined ? 350.00 : parseFloat(avgFurnaceJob).toFixed(2),
            avgAirHandlerJob: avgAirHandlerJob === null || avgAirHandlerJob === undefined ? 350.00 : parseFloat(avgAirHandlerJob).toFixed(2),
            avgAirConditionerJob: avgAirConditionerJob === null || avgAirConditionerJob === undefined ? 400.00 : parseFloat(avgAirConditionerJob).toFixed(2),
            avgHeatPumpJob: avgHeatPumpJob === null || avgHeatPumpJob === undefined ? 400.00 : parseFloat(avgHeatPumpJob).toFixed(2),
            maintenanceFee: maintenanceFee === null || maintenanceFee === undefined ? 0.00 : parseFloat(maintenanceFee).toFixed(2)
        }
        
        return partnerProps;
    }

    savePartnerProps()
    {
        const shadowId = parseInt(this.state.partnerProps?.shadowTwinAssetId, 10);
        if (!shadowId || isNaN(shadowId)) {
            console.log("savePartnerProps: no valid shadowTwinAssetId, skipping property update");
            return;
        }

        var startTime = performance.now();
        let propertyUpdateObj = {
            assetId: shadowId,
            names: "acCutoffTemp|electricPrice|gasPrice|avgFurnaceJob|avgAirHandlerJob|avgAirConditionerJob|avgHeatPumpJob|maintenanceFee",
            dataTypeIds: "1|1|1|1|1|1|1|1",
            values: `${this.state.partnerProps.acCutoffTemp}|${this.state.partnerProps.electricPrice}|${this.state.partnerProps.gasPrice}|${this.state.partnerProps.avgFurnaceJob}|${this.state.partnerProps.avgAirHandlerJob}|${this.state.partnerProps.avgAirConditionerJob}|${this.state.partnerProps.avgHeatPumpJob}|${this.state.partnerProps.maintenanceFee}`
        }
        this.setState({ propsLoading: true }, async () => {
            await AssetService.updateProperties(propertyUpdateObj)
                .then(response => {
                    if (this._isMounted)
                        this.setState({propsLoading: false}, () => {
                            var elapsedTime = performance.now() - startTime;
                            Timing("Partner Properties Loading", "loading", elapsedTime, "Partner Properties Loading");
                        });
                        this.getPartnerProps();
                })
                .catch(e => {
                    console.log(e);
                });
        });
    }

    getSubLevel(subId) {
        let subLevel = "Unknown";
        switch (subId) {
            case '1':
                subLevel = "Pro-IQ Essentials";
                break;
            case '2':
                subLevel = "Pro-IQ Essentials Plus";
                break;
            case '3':
                subLevel = "Pro-IQ Advanced";
                break;
            case '4':
                subLevel = "Pro-IQ Command";
                break;
            case '5':
                subLevel = "Pro-IQ Protect";
                break;
            default:
                subLevel = "Default";
                break;
        }
        return subLevel;
    }

    renderAccount() {
         let alertMuteUntilRow = this.props.isPartnerAdmin || this.props.roles.includes(roles.admin) || this.props.roles.includes(roles.superAdmin) ?
            <div className="row no-gutters flex-container border-bottom">
                <div className="col-sm-12 col-md-6 padded-15">
                    <div className="display-flex">
                        <div className="col">
                            <span>Silence AC Device Alerts Until: <i>{this.state.alertMuteDate}</i></span>
                        </div>
                        <div className="col">
                            <button
                                type="button"
                                className="secondary-btn btn-small btn-right"
                                onClick={this.openAlertMuteUntilModal}>
                                Silence AC Device Alerts
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            : null;

        let subscriptionRow = this.props.isPartnerAdmin ?
            <div className="row no-gutters flex-container" >
                <div className="col-sm-12 col-md-6 padded-15" >
                    <div className="row">
                        <div className="col">
                            <span>Subscription Level: <i>{this.getSubLevel(this.props.serviceTier)}</i></span>
                        </div>
                        <div className="col">
                            <button
                                type="button"
                                className="secondary-btn btn-small btn-right"
                                onClick={this.openSubscriptionModal}
                            >
                                Update Subscription Level
                                    </button>
                        </div>
                    </div>
                </div>
            </div>
            : null;

        let logoImage = this.state.logoUpdated ?
            <Image src={this.state.newLogoFile} className="logoUpdated" />
            : <Image src={
                this.state.currentPartner?.logoData
                    ? "data:image/png;base64," + this.state.currentPartner.logoData  // TT base64
                    : this.state.currentPartner?.logo
                        ? this.state.currentPartner.logo                              // RIS URL
                        : require("../../../img/NoImage2.png")
              } className="box-6h-10p" />;

        let iconImage = this.state.iconUpdated ?
            <Image src={this.state.newIconFile} className="logoUpdated" />
            : <Image src={
                this.state.currentPartner?.iconData
                    ? "data:image/png;base64," + this.state.currentPartner.iconData
                    : require("../../../img/NoImage2.png")
              } className="box-6h-10p" />;

        //show billing only if resideo, only admin can edit.
        let billingRow = this.props.roles.includes(roles.admin) || this.props.roles.includes(roles.customerSupport) ?
            <div className="row no-gutters flex-container" >
                <div className="col-sm-12 col-md-12">
                    <div className="white-container container-minHight100" >
                        <h5 className="sectionTitle">Billing</h5>
                        <form className="input-container">
                            <div className="row no-gutters element-mb-15" >
                                <div className="col-lg-6 col-xl-4 padded-15R" >
                                    <label htmlFor="billing">Billing Status</label>
                                    <select
                                        className="form-control"
                                        id="description"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.isBillable !== null ? this.state.currentPartner.isBillable : "0"}
                                        onChange={this.onChangeBilling}
                                        disabled={this.props.roles.includes(roles.admin) ? false : true}
                                    >
                                        <option value="1">Billable</option>
                                        <option value="0">Not Billable</option>
                                    </select>
                                </div>
                                <div className="col-lg-6 col-xl-4 padded-15R" >
                                    <label htmlFor="description">Contract Type</label>
                                    <div>
                                        <input 
                                            type="checkbox" 
                                            value="Service" 
                                            name="contractType" 
                                            onChange={e => this.onChangeContract(e)} 
                                            checked={this.state.selectedContractType?.includes('Service')} 
                                            disabled={(this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.isBillable === "1") ? false : true} 
                                        />
                                        &nbsp; Service Contract &nbsp;&nbsp;
                                        <input 
                                            type="checkbox" 
                                            value="Monitoring" 
                                            name="contractType" 
                                            onChange={e => this.onChangeContract(e)} 
                                            checked={this.state.selectedContractType?.includes('Monitoring')} 
                                            disabled={(this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.isBillable === "1") ? false : true} 
                                        />
                                        &nbsp; Monitoring Contract &nbsp;&nbsp;
                                        {(this.state.selectedContractType?.length ?? 0) === 0 && this.state.currentPartner.isBillable === "1" && <p className="lbl-red">Contract type must be selected.</p>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xl-4 padded-15R" >
                                    <label htmlFor="description">First Billing Date</label>
                                    <DatePicker
                                        customInput={<input className="txt-detail billingelement" />}
                                        id="billingDate"
                                        name="billingDate"
                                        selected={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.firstBillingDate !== null && this.state.currentPartner.firstBillingDate !== "" ? moment(this.state.currentPartner.firstBillingDate).toDate() : this.state.startTime.toDate()}
                                        onChange={date => { this.onChangeBillingDate(date); }}
                                        popperPlacement="top-end"
                                        popperProps={{
                                            positionFixed: true
                                        }}
                                        disabled={(this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.isBillable === "1") ? false : true}
                                    />
                                </div>
                                <div className="col-lg-6 col-xl-4 padded-15R" >
                                    <label htmlFor="description">Complementary Units</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="compUnits"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.complementaryUnits !== null && this.state.currentPartner.complementaryUnits !== '' ? this.state.currentPartner.complementaryUnits : 0}
                                        onChange={this.onChangeCompUnits}
                                        min="0"
                                        max="10"
                                        disabled={(this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.isBillable === "1") ? false : true}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            : null;
        let applicationTimeLine = this.state.selectedNotificationType?.includes("Email") ?
            <div className="col-lg-6 col-xl-4 pad-left-15" >
                <label htmlFor="description">Notification Time</label>
                    <select
                        className="form-control"
                        id="description"
                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.applicationNotificationTime !== null ? this.state.currentPartner.applicationNotificationTime : "0"}
                        onChange={this.onChangeApplicationNotificationTime}
                        disabled={this.props.roles.includes("ADMIN") ? false : true}
                    >
                        <option value="0">{notificationTime.every6hours}</option>
                        <option value="1">{notificationTime.daily}</option>
                        <option value="2">{notificationTime.weekly}</option>
                    </select>
            </div> : null
        //show escalationAlertRow only if resideo, only admin can edit.
        let escalationAlertRow = this.props.roles.includes("ADMIN") || this.props.roles.includes("CUSTOMER SUPPORT") ?
            <div className="row no-gutters displayFlex" >
                <div className="col-sm-12 col-md-12">
                    <div className="white-container minHeight100" >
                        <h5 className="sectionTitle">Alert Escalation </h5>
                        <form className="input-container">
                            <div className="row no-gutters margin-bottom-15" >
                                <div className="col-lg-6 col-xl-4 pad-left-15" >
                                    <label htmlFor="billing">Escalation Level</label>
                                    <select
                                        className="form-control"
                                        id="description"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.escalationType !== null ? this.state.currentPartner.escalationType : "0"}
                                        onChange={this.onChangeEscalation}
                                        disabled={this.props.roles.includes("ADMIN") ? false : true}
                                    >
                                        <option value="0">Medium</option>
                                        <option value="1">High</option>
                                    </select>
                                </div>

                                <div className="col-lg-6 col-xl-4 pad-left-15" >
                                    <label htmlFor="description">Notification Type</label>
                                    <div>
                                        <input
                                            type="checkbox"
                                            value="Application"
                                            name="contractType"
                                            onChange={e => this.onChangeNotificationType(e)}
                                            checked={this.state.selectedNotificationType?.includes('Application')}
                                            disabled={(this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.escalationType === "1") ? false : true}
                                        />
                                        &nbsp; Application &nbsp;&nbsp;
                                        <input
                                            type="checkbox"
                                            value="Email"
                                            name="contractType"
                                            onChange={e => this.onChangeNotificationType(e)}
                                            checked={this.state.selectedNotificationType?.includes('Email')}
                                            disabled={(this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.escalationType === "1") ? false : true}
                                        />
                                        &nbsp; Email &nbsp;&nbsp;
                                        {!(this.state.selectedNotificationType?.includes("Email") ||this.state.selectedNotificationType?.includes("Application")) && this.state.currentPartner.escalationType === "1" && <p className="color-red" >Notification type must be selected.</p>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xl-4 pad-left-15" >
                                    <label htmlFor="description">Alert Process</label>
                                    <div>
                                        <input
                                            type="checkbox"
                                            name="alertsToReview"
                                            onChange={e => this.toggleAlertsToReview(e)}
                                            checked={!!(this.state.currentPartner && this.state.currentPartner.alertsToReview)}
                                        />
                                        &nbsp; Send partner Alert to Triage Team Review &nbsp;&nbsp;
                                    </div>
                                </div>
                                {applicationTimeLine}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            : null;
           

        let partnerPropertiesRow = this.state.propsLoading ?
            <div className="row no-gutters flex-container" >
                <div className="col-sm-12 col-md-12">
                    <div className="white-container container-minhight100" >
                        <h5 className="sectionTitle">Properties</h5>
                        <form className="input-container">
                            <div className="row no-gutters element-mb-15" >
                                    <div className="modal-body"><Spinner animation="border" variant="dark"/></div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            :
            <div className="row no-gutters flex-container" >
                <div className="col-sm-12 col-md-12">
                    <div className="white-container container-minhight100" >
                        <h5 className="sectionTitle">Properties</h5>
                        <form className="input-container">
                            <div className="row no-gutters element-mb-15" >
                                <div className="col-md-6 col-lg-4 padded-box15" >
                                    <label htmlFor="description">AC Cutoff Temperature</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="acCutoffTemp"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? this.state.partnerProps.acCutoffTemp + " °F" : '0 °F'}
                                        onChange={this.onChangeAcCutoff}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4 padded-box15" >
                                    <label htmlFor="description">Default Electric Price</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="electricPrice"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? "$" + this.state.partnerProps.electricPrice : '$0.00'}
                                        onChange={this.onChangeElectricPrice}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-4 padded-box15" >
                                    <label htmlFor="description">Default Gas Price</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="gasPrice"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? "$" + this.state.partnerProps.gasPrice : '$0.00'}
                                        onChange={this.onChangeGasPrice}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>;

        let partnerJobValuesRow = this.state.propsLoading ?
            <div className="row no-gutters flex-container" >
                <div className="col-sm-12 col-md-12">
                    <div className="white-container container-minhight100" >
                        <h5 className="sectionTitle">Job Values</h5>
                        <form className="input-container">
                            <div className="row no-gutters element-mb-15" >
                                <div className="modal-body"><Spinner animation="border" variant="dark"/></div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            :
            <div className="row no-gutters flex-container" >
                <div className="col-sm-12 col-md-12">
                    <div className="white-container container-minhight100" >
                        <h5 className="sectionTitle">Job Values</h5>
                        <form className="input-container">
                            <div className="row no-gutters element-mb-15" >
                                <div className="col-sm-6 col-md-4 padded-box15"  title="This field represents the average $ amount charged for Furnace jobs.">
                                    <label htmlFor="description">Furnace</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="avgFurnaceJob"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? "$" + this.state.partnerProps.avgFurnaceJob : '$350.00'}
                                        onChange={this.onChangeAvgFurnaceJob}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                                <div className="col-sm-6 col-md-4 padded-box15"  title="This field represents the average $ amount charged for Air Handler jobs.">
                                    <label htmlFor="description">Air Handler</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="avgAirHandlerJob"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? "$" + this.state.partnerProps.avgAirHandlerJob : '$350.00'}
                                        onChange={this.onChangeAvgAirHandlerJob}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                                <div className="col-sm-6 col-md-4 padded-box15"  title="This field represents the average $ amount charged for Air Conditioner jobs.">
                                    <label htmlFor="description">Air Conditioner</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="avgAirConditionerJob"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? "$" + this.state.partnerProps.avgAirConditionerJob : '$400.00'}
                                        onChange={this.onChangeAvgAirConditionerJob}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                                <div className="col-sm-6 col-md-4 padded-box15"  title="This field represents the average $ amount charged for Heat Pump jobs.">
                                    <label htmlFor="description">Heat Pump</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="avgHeatPumpJob"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? "$" + this.state.partnerProps.avgHeatPumpJob : '$400.00'}
                                        onChange={this.onChangeAvgHeatPumpJob}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                                <div className="col-sm-6 col-md-4 padded-box15"  title="This field represents the $ amount charged to customers for LifeWhere.">
                                    <label htmlFor="description">Maintenance Fee</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="maintenanceFee"
                                        value={this.state.partnerProps !== null && this.state.partnerProps !== undefined ? "$" + this.state.partnerProps.maintenanceFee : '$0.00'}
                                        onChange={this.onChangeMaintenanceFee}
                                        onBlur={this.onBlurPropertiesField}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>;

        return (
            <div>
                <div className="row no-gutters flex-container" >
                    <div className="col-sm-12 col-md-6">
                        <div className="white-container container-minhight100" >
                            <h5 className="sectionTitle">Company</h5>
                            <form className="input-container">
                                <div>
                                    <label htmlFor="description">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.name  !== null ? this.state.currentPartner.name : ""}
                                        onChange={this.onChangeName}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="description">Display Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="display-name"
                                        defaultValue={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.company !== null ? this.state.currentPartner.company : ""}
                                        onChange={this.onChangeDisplayName}
                                    />
                                </div>
                                <div className="marginBottom-10">
                                    <label htmlFor="description">Description</label>
                                    <input 
                                        type="text"
                                        className="form-control"
                                        id="description"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.description !== null ? this.state.currentPartner.description : ""}
                                        onChange={this.onChangeDescription}
                                    />
                                </div>
                                
                                
                            <span>Logo:</span>
                            <div className="row">
                                    <div className="col">
                                        <span className="display-none">logoId={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.logoId : ""}</span>
                                        {logoImage}
                                </div>
                                <div className="col">
                                        {(!this.state.isCustomerSupport) && (
                                            <button
                                                type="button"
                                                className="secondary-btn btn-small btn-right"
                                                onClick={this.openLogoModal}
                                            >
                                                Update
                                            </button>)}
                                </div>
                            </div>
                            <span>Icon:</span>
                            <div className="row">
                                    <div className="col">
                                        <span className="none-display">iconId={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.iconId : ""}</span>
                                        {iconImage}
                                </div>
                                <div className="col">
                                        {(!this.state.isCustomerSupport) && (
                                            <button
                                                type="button"
                                                className="secondary-btn btn-small btn-right"
                                                onClick={this.openIconModal}
                                            >
                                                Update
                                            </button>)}
                                </div>
                            </div>
                            </form>
                            
                                    <div className="margin-20-30">
                                        <label htmlFor="description">ProPerks Number</label>
                                        <label
                                            className="form-control"
                                            id="ProPerksNumber"
                                        >
                                            {this.state.currentPartner?.proPerksNumber ?? ""}
                                        </label>
                                   
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="white-container container-minhight100" >
                            <h5 className="sectionTitle">Contact</h5>
                            <form className="input-container">
                                <div>
                                    <label htmlFor="description">Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="address"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.address : ''}
                                        onChange={this.onChangeAddress}
                                        />
                                </div>
                                <div>
                                    <label htmlFor="description">City</label>
                                    <input 
                                        type="text"
                                        className="form-control"
                                        id="city"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.city : ''}
                                        onChange={this.onChangeCity}
                                        />
                                </div>
                                <div>
                                    <label htmlFor="description">State</label>
                                    <input 
                                        type="text"
                                        className="form-control"
                                        id="state"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.state : ''}
                                        onChange={this.onChangeState}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="description">Zip</label>
                                    <input 
                                        type="text"
                                        className="form-control"
                                        id="zip"
                                        value={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.zip : ''}
                                        onChange={this.onChangeZip}
                                        />
                                </div>
                                <div>
                                    <PhoneNumberInput
                                        phoneNumber={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.phone : ''}
                                        setPhoneNumber={this.onChangePhone}
                                        onError={this.handleError}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="description">System Notification Emails</label>
                                    <AddMultipleEmailAddresses existingEmailAddresses={this.state.currentPartner !== null && this.state.currentPartner !== undefined ? this.state.currentPartner.notificationEmailAddresses : []}
                                        onAddEmailClicked={this.onAddEmailClicked}
                                        onDeleteEmailClicked={this.onDeleteEmailClicked}
                                        onEmailChanged={this.onEmailChanged} showMessage={true}/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {billingRow}
                {/*{partnerPropertiesRow}*/}
                {/*{partnerJobValuesRow}*/}
                {subscriptionRow}
                {escalationAlertRow}
                {alertMuteUntilRow}

                <br />
                <br /><br />
            </div>
        );
    }

    //TODO set up image error handling!

    //LFWCS-56 - HIDE ALERT MESSAGE TABLE
    //<h5>Alert Message Setup</h5>
                //<table className='table table-striped table-bordered table-sm table-hover' aria-labelledby="tabelLabel" style={{ width: '95%' }}>
                //    <thead>
                //        <tr >
                //            <th>Name</th>
                //            <th>Description</th>
                //            <th>Priority Name</th>
                //            <th>Message</th>
                //            <th>Message Details</th>
                //        </tr>
                //    </thead>
                //    {tableContent}
                //</table>

    render() {
        const { classes } = this.props;

        let notPartnerAdminMsg = <div className="margin-left-10">
            <br />
            <h5>Must be a Partner Admin to access this page!</h5>
        </div>;

        let contents = this.state.loading ?
            <Loader />
            : ((this.props.roles.includes("PARTNER ADMIN") || this.props.roles.includes("ADMIN") || this.props.roles.includes("CUSTOMER SUPPORT"))  ?
                this.renderAccount()
                : notPartnerAdminMsg
            );

        return (
            <div sx={(theme) => ({
                [theme.breakpoints.down('md')]: {
                marginLeft: '-225px !important',
            },
            }) }>
                <div className="infoPage">
                    <div className="row no-gutters">
                        <div className="col">
                            <h3 className="pageTitle" id="tableLabel">Partner Account</h3>
                        </div>
                       
                        <div className="col pageTitle">
                            {(!this.state.isCustomerSupport) && (
                                <div className="btn-right">
                                    <p className="status-msg margin-right-10" >{this.state.message}</p>
                                    <button type="button" className="secondary-btn btn-large"
                                            onClick={this.openCancelModal}
                                            disabled={this.props.roles.includes("PARTNER ADMIN") || this.props.roles.includes("ADMIN") ? false : true}>Cancel
                                    </button>
                                    <button type="button" className="primary-btn btn-large" onClick={this.openSaveModal}
                                            disabled={this.props.roles.includes("PARTNER ADMIN") || this.props.roles.includes("ADMIN") ? (!!this.state.error || (!(this.state.currentPartner.proPartnerAccountId && !this.state.currentPartner.organizationId) && !this.state.currentPartner.phone) || this.state.isUpdating || (this.state.selectedContractType?.length === 0 && this.state.currentPartner.isBillable === "1")) : true}>Save
                                    </button>
                                </div>)}
                        </div>
                    </div>
                    {contents}
                    {!this.state.loading && ((this.props.roles.includes("PARTNER ADMIN") || this.props.roles.includes("ADMIN")) && (this.state.currentPartner !== null && this.state.currentPartner !== undefined && this.state.currentPartner.betaST)) &&
                        <AddIntegration currentAccount={this.props.currentAccount} partnersId={this.state.currentPartner.organizationId} />
                    }
                    <ConfirmationModal show={this.state.showCancelConfirm} onYes={this.onCancel} onClick={this.showCancelModal} message={this.state.modalMessage} title={this.state.modalTitle}></ConfirmationModal>
                    <ConfirmationModal show={this.state.showSaveConfirm} onYes={this.onSave} onClick={this.showSaveModal} message={this.state.modalMessage} title={this.state.modalTitle}></ConfirmationModal>
                    <ConfirmationModal show={this.state.showUnsavedModal == null ? this.getStorageValue("showUnsavedModal", false) === 'true' : this.state.showUnsavedModal} onYes={this.onSaveThenContinue} onClick={this.onContinueWithoutSaving} message={"You have unsaved changes, would like to save before leaving?"} title={"Unsaved Changes"}></ConfirmationModal>
                    <MuteAlertConfirmationModal show={this.state.showMuteAlertConfirm} onYes={this.onSaveAlertMuteDate} onClick={this.openAlertMuteUntilModal} message={this.state.modalMessage} title={this.state.modalTitle} selectedMutedDate={this.state.selectedMutedDate} onChangeMuteUntillDate={this.onChangeMuteUntillDate}></MuteAlertConfirmationModal>
                    <UpdateImageModal show={this.state.showLogoUpdate} onYes={this.onUpdateLogo} onClick={this.showLogoModal} handleImageChange={this.handleLogoChange} message={this.state.modalMessage} title={this.state.modalTitle}></UpdateImageModal>
                    <UpdateImageModal show={this.state.showIconUpdate} onYes={this.onUpdateIcon} onClick={this.showIconModal} handleImageChange={this.handleIconChange} message={this.state.modalMessage} title={this.state.modalTitle}></UpdateImageModal>

                </div>
            </div>
        );
    }
}

export default withRouter(AccountManagement);
